import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './net-metering-policy.reducer';

export const NetMeteringPolicyDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const netMeteringPolicyEntity = useAppSelector(state => state.netMeteringPolicy.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="netMeteringPolicyDetailsHeading">
          <Translate contentKey="crawlerBackendApp.netMeteringPolicy.detail.title">NetMeteringPolicy</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{netMeteringPolicyEntity.id}</dd>
          <dt>
            <span id="effectiveDate">
              <Translate contentKey="crawlerBackendApp.netMeteringPolicy.effectiveDate">Effective Date</Translate>
            </span>
          </dt>
          <dd>
            {netMeteringPolicyEntity.effectiveDate ? (
              <TextFormat value={netMeteringPolicyEntity.effectiveDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="percentage">
              <Translate contentKey="crawlerBackendApp.netMeteringPolicy.percentage">Percentage</Translate>
            </span>
          </dt>
          <dd>{netMeteringPolicyEntity.percentage}</dd>
        </dl>
        <Button tag={Link} to="/net-metering-policy" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/net-metering-policy/${netMeteringPolicyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default NetMeteringPolicyDetail;
